<template>
  <div class="ui-alert-popup-component-wrapper" @click="close">
    <div class="ui-alert-popup-component">
      <div class="alert-popup-body">
        <div class="alert-popup-icon" v-if="type" :class="type">
          <i class="fa-solid" :class="typeIcon" />
        </div>
        <h3 class="alert-popup-title" v-if="title" v-text="title" />
        <div class="alert-popup-message" v-if="message">
          <p v-text="message" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import type { IAlert } from '@/types/Components/Popup'
  import { computed } from 'vue'

  const { type = 'warning', title, message } = defineProps<IAlert>()

  const emits = defineEmits(['response'])

  const typeIcon = computed(() => {
    switch (type) {
      case 'success':
        return 'fa-circle-check'
      case 'danger':
        return 'fa-circle-xmark'
      case 'warning':
        return 'fa-circle-exclamation'
      case 'info':
        return 'fa-circle-info'
      default:
        return ''
    }
  })

  const close = () => {
    emits('response', false)
  }
</script>

<style lang="scss">
  .ui-alert-popup-component-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    .ui-alert-popup-component {
      width: 100%;
      max-width: 400px;
      background-color: $white;
      border-radius: 4px;
      animation: fadeIn 0.25s ease-in-out forwards;
      @include media(xs, sm, md) {
        width: calc(100% - 2rem);
      }
      @keyframes fadeIn {
        0% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
      }
      .alert-popup-body {
        padding: 20px;
        .alert-popup-icon {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 10px;
          font-size: 3rem;
          &.warning {
            color: $warning;
          }
          &.success {
            color: $success;
          }
          &.danger {
            color: $danger;
          }
          &.info {
            color: $info;
          }
        }
        .alert-popup-title {
          font-size: 1.25rem;
          font-weight: 600;
          text-align: center;
          margin-bottom: 10px;
          color: $primary-text-color;
        }
        .alert-popup-message {
          font-size: 1rem;
          text-align: center;
          color: $primary-text-color;
        }
      }
    }
  }
</style>
